module.exports = __webpack_public_path__ + "img/jr_banner_pt.30bbe0e0.jpg";